module.exports = __webpack_public_path__ + "static/img/3069_phase_function_Paper_PointsHejduk_Prediction.88c9418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3069_phase_function_Paper_PointsHejduk_Prediction.png
// module id = C0kC
// module chunks = 0